import React from "react";
import { Card, CardContent, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { numberPrecision } from "../../../../helpers/UtilityHelper";
import { Box } from "@mui/system";
import _ from 'lodash'
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';
import BarChartIcon from '@mui/icons-material/BarChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import ChartTooltip from "../../../charts/ChartTooltip";
import ChartEmpty from "../../../charts/ChartEmpty";
import useGetCourier from "../useGetCourier";
import { HOUR_BUCKETS } from "./useStuckShipment";

const HOUR_COLORS = ['#5EB8F4', '#3B9AE1', '#1F7FCC', '#0F6BB5', '#0855A0', '#052F6F']

export default function CourierStatusWiseSplit({ data, title, isCourierView }) {
    const [view, setView] = React.useState("chart")

    const { data: allCouriers = [] } = useGetCourier();
    const couriersGroupedById = _.groupBy(allCouriers, 'id');

    data.forEach((item) => {
        if (item.name && couriersGroupedById[item.name]) {
            const courier = couriersGroupedById[item.name][0];
            const courierName = courier ? (courier.parent || courier.name) : undefined;

            if (courierName) {
                item.name = courierName;
            }
        }
    })

    const stackedData = _.orderBy(data, 'count', 'desc').slice(0, 20)
    const chartHeight = Math.max(240, stackedData.length * 40 + 120)
    const yAxisLabel = isCourierView ? 'Courier Name' : 'Status'

    return (
        <Card elevation={1}>
            <CardHeader title={title} action={(
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ToggleButtonGroup sx={{ ml: 1 }} color="primary" size="small" exclusive onChange={(e, v) => setView(v)} value={view}>
                        <ToggleButton value="chart" title="View Data In %">
                            <BarChartIcon />
                        </ToggleButton>
                        <ToggleButton value="table" title="View Data In Count">
                            <TableChartIcon />
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            )} />

            <CardContent>
                {view === 'chart' && (
                    (!stackedData || stackedData.length === 0) ? <ChartEmpty height={chartHeight} /> : (
                    <ResponsiveContainer width="100%" height={chartHeight}>
                        <ComposedChart data={stackedData} layout="vertical" margin={{ top: 30, right: 20, bottom: 20, left: 40 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#dee2e6" />
                            <XAxis type="number" fontSize="11px" fontWeight="500" />
                            <YAxis type="category" dataKey="name" fontSize="11px" fontWeight="500" width={140} label={{ value: yAxisLabel, angle: -90, position: 'insideLeft', fontSize: 11, fill: '#666', textAnchor: 'middle' }} />
                            <Tooltip content={<ChartTooltip />} />
                            <Legend verticalAlign="top" align="center" iconSize="10px" iconType="square" wrapperStyle={{ fontSize: 11, fontWeight: 500, paddingBottom: 10 }} />
                            {HOUR_BUCKETS.map((b, i) => {
                                const isLast = i === HOUR_BUCKETS.length - 1
                                return (
                                    <Bar
                                        key={b}
                                        dataKey={b}
                                        name={b}
                                        stackId="hours"
                                        fill={HOUR_COLORS[i]}
                                        maxBarSize={40}
                                        animationEasing="ease-in-out"
                                        animationDuration={1000}
                                    >
                                        {isLast && (
                                            <LabelList dataKey="count" position="right" style={{ fontSize: 10, fontWeight: 600, fill: '#374151' }} formatter={(v) => (v == null || v === 0) ? '' : v} />
                                        )}
                                    </Bar>
                                )
                            })}
                        </ComposedChart>
                    </ResponsiveContainer>
                    )
                )}

                {view === 'table' && (
                    <TableContainer>
                        <Table size="small" density>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Number Of Shipments</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {_.orderBy(data, 'count', 'desc').map((row, i) => {
                                    return (
                                        <TableRow key={i}>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{numberPrecision(row.count)}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </CardContent>
        </Card>
    )
}
